import type { GoodsData } from '@banhala/ui-kit';
import { AblyGoodsCardChipType } from 'shared/src/api/types';
import type { LikedGoodsItem } from 'shared/src/api';

export type LikedGoodsCardItem = GoodsData & LikedGoodsItem;

/**
 * `LikedGoodsItem` ({ item, render, logging }) → `GoodsData` 평면화.
 * MarketHomeGoodsItem 컨버터와 동일한 구조이지만 `render.data.chips`(AtomicChip)의
 * 일부 variant에 `name`이 optional이라 공용 util을 그대로 못 써서 인라인 매핑.
 */
export const convertLikedGoodsItemToGoodsData = (
  entity: LikedGoodsItem,
): LikedGoodsCardItem => {
  const { item, render } = entity;
  const data = render.data;

  return {
    ...entity,
    sno: item.sno,
    deliveryType: item.delivery_type,
    thumbnail: {
      src: data.image.url,
      freesSrc: data.image.url,
      closedReason: data.closed_reason ?? undefined,
      badges: data.image_badge_list.map(badge => ({
        uri: badge.image_url,
        width: badge.image_width,
        height: badge.image_height,
      })),
      emblems: data.emblems?.map(emblem => ({ uri: emblem.image_url })),
    },
    contents: {
      price: {
        price: data.price,
        discount: data.discount_rate ?? undefined,
      },
      name: {
        goodsName: item.name,
        marketName: data.store_text ?? item.market_name ?? null,
        nameLineCount: data.name_lines,
        showBrand: false,
      },
      imageAd: data.has_ad_badge,
      nudge: data.nudging_text ?? undefined,
      chips: (data.chips ?? []).map(chip => {
        if (chip.type === AblyGoodsCardChipType.DittoText) {
          return {
            type: chip.type,
            name: chip.name,
            customTag: {
              bgColor: chip.meta.bg_color,
              borderColor: chip.meta.border_color,
              borderWidth: chip.meta.border_width ?? 0,
              borderRadius: chip.meta.rounded_corner_radius ?? 0,
              textColor: chip.meta.text_color,
              textType: chip.meta.text_style,
            },
          };
        }
        return {
          type: chip.type,
          name: chip.name ?? '',
        };
      }),
      topNudging: data.top_nudging_text ?? undefined,
      priceDescription: data.price_description
        ? { name: data.price_description.text }
        : undefined,
    },
  };
};
